// extracted by mini-css-extract-plugin
module.exports = {"list":"tac-ops-list-module__list___2yikm","setTitle":"tac-ops-list-module__setTitle___2ev_3","categoryTitle":"tac-ops-list-module__categoryTitle___29-aE"};